import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { Row,Col, Card, Form, Button, } from 'react-bootstrap';
import {Helmet} from "react-helmet";
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase
} from '../../../utils';
import axios from 'axios';

import PsContext from '../../context/PsContext';

class Policy extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			count: [],
		}
	}
	
	componentDidMount(){
		
		this.context.updateHeader({
			top: false,
			title: 'Policy',
			back: true,
		});
		
	}
	
	componentWillUnmount(){
		
		this.context.updateHeader({top: false});		
	}
	
	render(){

		return(
			<React.Fragment>
				
					<h1>Policy</h1>
			
			</React.Fragment>
		);
	}
	
}
export default Policy;
